import Vue from 'vue'

import ElementUI from 'element-ui';
Vue.use(ElementUI);
import VueResource from "vue-resource"
Vue.use(VueResource);
Vue.http.options.credentials = true;

import App from './App'

import 'element-ui/lib/theme-chalk/index.css';
import router from './router'

Vue.config.productionTip = false

import utils from '@/utils'
Vue.use(utils)

import YUI from './components/YUI'
Vue.use(YUI)

// CDN 域名，用于存储图片等静态资源，加快加载速度
// css 中无法使用变量，所以css中暂时先写死
Vue.prototype.$GLOBAL_CDN_URL = 'https://cdn.smsat.space'

import './styles/index.less'

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js